import React from 'react';
import { Image } from 'wix-rich-content-ui-components';
import { s as styleInject } from '../style-inject.es-e7b07dd7.js';
import { ROOT } from '../dataHooks.js';

var css_248z = ".lwvDj{display:block;width:100%}._-7IPL{position:relative;width:100%}._-7IPL:before{content:\"\";display:block;width:100%}[dir] ._-7IPL:before{padding-bottom:calc(var(--dim-height)/var(--dim-width)*100%)}._-7IPL>:first-child{bottom:0;position:absolute;top:0}[dir=ltr] ._-7IPL>:first-child,[dir=rtl] ._-7IPL>:first-child{left:0;right:0}";
var styles = {"giphy_player":"lwvDj","gifRatio":"_-7IPL"};
styleInject(css_248z);

const GiphyViewer = (props) => {
  const { componentData } = props;
  const { id, width, height } = componentData;
  if (componentData.original.mp4) {
    return /* @__PURE__ */ React.createElement(
      "video",
      {
        role: "img",
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        "aria-label": "gif",
        "data-hook": ROOT,
        className: styles.giphy_player,
        src: componentData.original.mp4
      }
    );
  }
  const isInfoForWixImageReady = id !== void 0 && width !== void 0 && height !== void 0;
  if (isInfoForWixImageReady) {
    return /* @__PURE__ */ React.createElement(
      Image,
      {
        id,
        containerId: `${id}-parent`,
        role: "img",
        "aria-label": "gif",
        height,
        width,
        containerProps: {
          className: styles.gifRatio,
          containerId: `${id}-parent`,
          style: {
            ["--dim-height"]: height,
            ["--dim-width"]: width
          },
          dataHook: ROOT
        },
        displayMode: "fill",
        className: styles.giphy_player,
        uri: componentData.original.gif,
        alt: "gif"
      }
    );
  }
  return /* @__PURE__ */ React.createElement(
    "img",
    {
      role: "img",
      "aria-label": "gif",
      className: styles.giphy_player,
      src: componentData.original.gif,
      alt: "gif",
      "data-hook": ROOT
    }
  );
};

export { GiphyViewer as default };
//# sourceMappingURL=giphy-viewer.js.map
